import React from 'react';

import { Outlet } from 'react-router-dom';

import { CustomerHeader } from 'components';

/**
 * Layout route for the logged-in customer area. Renders CustomerHeader once
 * and an <Outlet /> for whichever child route matched, instead of every
 * screen importing and rendering the header itself.
 *
 * Mounted as a wrapping <Route> with no `path` in CustomerRoutes — children
 * nested under it inherit this layout automatically. Routes that should NOT
 * show the header (sign-in, sign-up flow, onboarding, forgot-password, etc.)
 * stay as siblings outside this wrapper.
 *
 * CustomerHeader is now wrapped in a sticky container (inline style, since
 * this file has no CSS module of its own and the only rule needed is
 * position/offset/stacking — didn't seem worth introducing a whole new
 * styles file for three properties). This is the actual header shown on
 * every customer-area page — AppWrapper also has its own optional
 * `showHeader`/<Header> (from `containers`), but that's a different,
 * unrelated component that isn't even being rendered on pages like
 * CouponsListAll, which is why making sticky work there previously had no
 * visible effect: it was never the right element to begin with.
 */
const CustomerLayout = () => (
  <>
    <div style={{ position: 'sticky', top: 0, zIndex: 1200 }}>
      <CustomerHeader />
    </div>
    <Outlet />
  </>
);

export default CustomerLayout;